
import Vue, { PropType } from 'vue'
import {Contest, ContestPage} from '@/model/Contest'
import moment from 'moment'
import TermsDialog from '@/components/contest/TermsDialog.vue'

interface Data {
  termsDialog: boolean;
  isAppliedToContest: boolean;
  timer: number;
  timerInterval: ReturnType<typeof setInterval> | null;
}

const ONE_MINUTE = 60;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;

export default Vue.extend({
  name: 'ContestItem',

  components: {
    TermsDialog,
  },

  props: {
    contest: {
      type: Object as PropType<ContestPage>,
    },

    isActiveApplyContest: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    daysLeft: function () {
      const endAt = new Date(this.contest.finishedAt);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      endAt.setHours(0, 0, 0, 0);

      return moment(endAt).diff(moment(today), 'days')
    },

    daysLeftPretty: function (): string {
      const daysLeft = (this as any).daysLeft

      if (daysLeft > 1) {
        return daysLeft + ' days left'
      }

      return daysLeft + ' day left'
    },

    daysToStart: function () {
      const startAt = new Date(this.contest.startAt);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      startAt.setHours(0, 0, 0, 0);

      return moment(startAt).diff(moment(today), 'days')
    },

    daysToStartPretty: function (): string {
      const daysToStart = (this as any).daysToStart

      if (daysToStart > 1) {
        return daysToStart + ' days to start'
      }

      if (daysToStart === 0) {
        return 'It starts today!'
      }

      return daysToStart + ' day to start'
    },

    isBeforeStart: function () {
      return moment().isBefore(this.contest.startAt)
    },

    isComingSoon: function () {
      return moment().isBefore(this.contest.publicFrom)
    },

    isLastDay: function () {
      const diff = moment(this.contest.finishedAt).diff(moment(), 'seconds');
      if (diff <= 0) return false;

      return diff <= ONE_DAY;
    },

    isFinished: function () {
      return moment().isAfter(this.contest.finishedAt)
    },

    hasRewardsValue: function () {
      return Number(this.contest.reward) > 0
    },

    formattedTimer: function () {
      if (this.timer >= ONE_HOUR) {
        return Math.floor(this.timer / ONE_HOUR) + ' hours left';
      }

      if (this.timer >= ONE_MINUTE) {
        return Math.floor(this.timer / ONE_MINUTE) + ' minutes left';
      }

      if (this.timer > 0) {
        return this.timer + ' seconds left';
      }

      return '';
    }
  },

  methods: {
    hideContestItem: function (appliedToContest: boolean) {
      return appliedToContest && (this.isAppliedToContest = !this.isAppliedToContest)
    },

    initializeTimer: function() {
      if (!this.isLastDay) return;

      this.timer = moment(this.contest.finishedAt).diff(moment(), 'seconds');
      this.timerInterval = setInterval(() => {
        this.timer = moment(this.contest.finishedAt).diff(moment(), 'seconds');
        if (this.timer <= 0) {
          if (this.timerInterval) clearInterval(this.timerInterval);
          (this.$refs.wrapper as HTMLDivElement).parentElement?.remove();
        }
      }, 1000)
    },
  },

  mounted() {
    this.initializeTimer();
  },

  data: (): Data => ({
    termsDialog: false,
    isAppliedToContest: false,
    timer: 0,
    timerInterval: null,
  }),
})
